import { useEffect, useState } from "react";

import { LiveChatPhaseEnum } from "@twiliointernal/e2-commons-shared-definitions";
import { ConversationUpdatedEventArgs, JSONValue } from "@twilio/conversations";
import { getAttribute } from "../../../../utils";
import { ConversationEvents } from "../../../../services/conversations/definitions/constants";
import { ConversationServiceReadyEvent } from "../../../../services/conversations/definitions/types";
import chatService from "../../../../services/conversations/conversationsService";

const useChatService = () => {
  const [isChatActive, setIsChatActive] = useState(false);

  const initChatService = () => {
    const handleChatPhase = (attributes: JSONValue) => {
      const chatPhase = getAttribute({
        attributes,
        key: "chatPhase",
        fallbackValue: LiveChatPhaseEnum.Waiting,
      }) as string;
      setIsChatActive(chatPhase === LiveChatPhaseEnum.Active);
    };

    const handleConversationUpdated = (event: ConversationUpdatedEventArgs) => {
      handleChatPhase(event.conversation.attributes);
    };

    const handleChatServiceReady = (event: ConversationServiceReadyEvent) => {
      handleChatPhase(event.attributes);
    };

    chatService.addEventListener<ConversationUpdatedEventArgs>(
      ConversationEvents.Updated,
      handleConversationUpdated
    );

    chatService.addEventListener<ConversationServiceReadyEvent>(
      ConversationEvents.Ready,
      handleChatServiceReady
    );

    return () => {
      chatService.removeEventListener<ConversationUpdatedEventArgs>(
        ConversationEvents.Updated,
        handleConversationUpdated
      );

      chatService.removeEventListener<ConversationServiceReadyEvent>(
        ConversationEvents.Ready,
        handleChatServiceReady
      );
    };
  };

  useEffect(initChatService, []);

  const sendChatMessage = ({
    body,
    files,
  }: {
    body: string;
    files: File[];
  }) => {
    return chatService.sendMessage({ body, files });
  };

  const notifyStartTyping = () => {
    chatService.startTyping();
  };

  const onChatError = (error: Error) => {
    chatService.setError(error.message);
  };

  return {
    sendChatMessage,
    isChatActive,
    onChatError,
    notifyStartTyping,
  };
};

export default useChatService;
